// @flow
import type {Node} from 'react'
import React from 'react'
import {graphql, useFragment} from 'react-relay'

import Builder from 'components/proposals/Builder'
import Preload from 'components/ui/Preload'
import CirclePicker from './CirclePicker'
import type {OrganizationKey, Proposal, ViewerKey} from './types'

type Props = {
  createProposalForCircleId: (string) => void,
  deletionInFlight: boolean,
  organization: OrganizationKey,
  proposal: ?Proposal,
  proposalLoading: boolean,
  viewer: ViewerKey,
  circleDatabaseId: string | null,
  providedTension?: ?string,
}

const viewerFragment = graphql`
  fragment ProposalCreatorBody_viewer on Person {
    ...CirclePicker_viewer
  }
`

const organizationFragment = graphql`
  fragment ProposalCreatorBody_organization on Organization {
    ...Builder_organization
  }
`

function ProposalCreatorBody({
  createProposalForCircleId,
  deletionInFlight,
  organization: organizationKey,
  proposal,
  proposalLoading,
  viewer: viewerKey,
  circleDatabaseId,
  providedTension,
}: Props): null | Node {
  const viewer = useFragment(viewerFragment, viewerKey)
  const organization = useFragment(organizationFragment, organizationKey)

  if (proposal === null && !proposalLoading) {
    return (
      <CirclePicker
        circleDatabaseId={circleDatabaseId}
        createProposalForCircleId={createProposalForCircleId}
        viewer={viewer}
      />
    )
  }

  if (proposal === null && proposalLoading)
    return <Preload />

  if (proposal !== null && deletionInFlight)
    return <Preload />

  return (
    proposal
      ? (
        <Builder
          disabled={deletionInFlight}
          isHost
          meeting={null}
          organization={organization}
          proposal={proposal}
          isModal
          providedTension={providedTension}
        />
      )
      : null
  )
}

ProposalCreatorBody.defaultProps = {
  proposal: null,
}

export default ProposalCreatorBody
